import React from 'react';
import type { ColumnsType } from 'antd/es/table';
import { useGetSellerVehiclesQuery } from '../../../app/api/vehicleApiSlice';
import Vehicle from '../../../core/models/Vehicle';
import { Table, Tag } from 'antd';
import { convertToCurrencyString } from '../../../utils/currencyUtil';
import { useNavigate } from 'react-router-dom';
import VehicleStatus from '../../../core/enum/VehicleStatus';
import VehicleStatusColorCode from '../../../core/enum/VehicleStatusColorCode';
import { formatCreatedDate } from '../../../utils/dateTimeUtil';

interface IProps {
  sellerId: string;
}

const statusFilter = Object.values(VehicleStatus)
  .filter((value) => isNaN(Number(value)))
  .map((status) => ({
    text: status.toString(),
    value: status.toString(),
  }));

const columns: ColumnsType<Vehicle> = [
  {
    title: 'VID',
    dataIndex: 'code',
    key: 'code',
    sorter: (a, b) => a.code.localeCompare(b.code),
  },
  {
    title: 'Registration No.',
    dataIndex: 'plateNumber',
    key: 'plateNumber',
    sorter: (a, b) => a.plateNumber.localeCompare(b.plateNumber),
  },
  {
    title: 'Make',
    dataIndex: 'make_Text',
    key: 'make',
    sorter: (a, b) => a.make - b.make,
    responsive: ['md'],
  },
  {
    title: 'Model',
    dataIndex: 'model_Text',
    key: 'model',
    sorter: (a, b) => a.model - b.model,
    responsive: ['md'],
  },
  {
    title: 'YoM',
    dataIndex: 'yom',
    key: 'yom',
    sorter: (a, b) => a.yom - b.yom,
    responsive: ['md'],
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status: VehicleStatus) => (
      <Tag color={VehicleStatusColorCode[status]}>{VehicleStatus[status]}</Tag>
    ),
    sorter: (a, b) => a.status - b.status,
    filters: statusFilter,
    onFilter: (value, record) => {
      return VehicleStatus[record.status] === value;
    },
  },
  {
    title: 'Created Date',
    dataIndex: 'createdDate',
    key: 'createdDate',
    render: (date: Date) => {
      return <>{formatCreatedDate(date)}</>;
    },
    sorter: (a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
    defaultSortOrder: 'descend',
  },
];

const ViewSellerVehicles: React.FC<IProps> = ({ sellerId }: IProps) => {
  const navigate = useNavigate();
  const { data: sellerVehicles, isLoading } = useGetSellerVehiclesQuery(sellerId);

  return (
    <Table
      dataSource={sellerVehicles}
      columns={columns}
      rowKey='id'
      loading={isLoading}
      size='small'
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            navigate(`/vehicles/${record.id}`);
          },
        };
      }}
    />
  );
};

export default ViewSellerVehicles;
